import { TicketOfficeView } from '../../../types/ticket-office';
import { FloorplanProps } from '../../components/FloorPlan';
import { applyStateToFloorplan } from '../floorplan_utils';
import { toggleSeat } from './seat-utils';

export const getFloorPlanProps = (view: TicketOfficeView): FloorplanProps => {
    const { state } = view;

    const data = applyStateToFloorplan(state.floorplanData, state.seats);

    if (!data.maxWidth || data.maxWidth > 1200) {
        data.maxWidth = 1200;
    }

    return {
        data,
        texts: {
            screen: state.lang.floorplan.screen,
            entrance: state.lang.floorplan.entry,
            stage: state.lang.floorplan.stage,
            balcony: state.lang.floorplan.balcony,
            sideBalcony: state.lang.floorplan.sideBalcony,
            lodges: state.lang.floorplan.lodges,
        },
        onClickSeat: (rowNumber: number, seatNumber: number, sectionId?: string): Promise<void> =>
            toggleSeat(
                view,
                rowNumber,
                seatNumber,
                sectionId,
                // Find section name based on section ID
                (() => {
                    if (sectionId && data.sections) {
                        const section = data.sections.find((s) => s.id === sectionId);
                        if (section) {
                            return section.name;
                        }
                    }
                    return undefined;
                })()
            ),
        isLoading: state.pendingOps.size > 0,
        showZoomControls: data.showZoomControls ?? false,
    };
};
